import { MembershipStatusDTO, MEMBERSHIP_STATUS } from '@pya-mms/common';
import axios from 'axios';
import { FC } from 'react';
import { useQuery } from 'react-query';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../store';
import StripeUnpaidMembershipCheckout from '../../../Payments/Stripe/StripeUnpaidMembershipCheckout';
import { Skeleton, Text } from '../../../ui';
import { FlexContainer } from '../../../ui/Container';

const fetchUnpaidMembership = async (userId: string): Promise<MembershipStatusDTO | null> => {
  try {
    const { data } = await axios.get(`/users/${userId}/membership-status`);
    if (data?.data && data.data.length > 0) {
      // Find the unpaid membership
      const unpaid = data.data.find((ms: MembershipStatusDTO) => ms.Status === MEMBERSHIP_STATUS.UNPAID);
      return unpaid || null;
    }
    return null;
  } catch (error) {
    console.error('Error fetching membership status:', error);
    return null;
  }
};

const PaymentStep: FC = () => {
  const authUser = useSelector((state: RootState) => state.auth.user);

  const {
    data: membershipStatus,
    isLoading,
    isError,
  } = useQuery(['unpaidMembership', authUser?._id], () => fetchUnpaidMembership(authUser?._id), {
    enabled: !!authUser?._id,
    refetchOnWindowFocus: false,
  });

  if (isLoading) {
    return (
      <FlexContainer flexDirection="column" gap="md" align="center">
        <Text weight="semibold" size="lg" style={{ textAlign: 'center' }}>
          Preparing Payment
        </Text>
        <FlexContainer flexDirection="column" gap="xs" style={{ width: '100%', maxWidth: '500px' }}>
          <Skeleton height={40} count={5} />
        </FlexContainer>
      </FlexContainer>
    );
  }

  if (isError || !membershipStatus) {
    return (
      <FlexContainer flexDirection="column" gap="md" align="center">
        <Text weight="semibold" size="lg" style={{ textAlign: 'center' }}>
          Payment Setup
        </Text>
        <Text color="error" style={{ textAlign: 'center' }}>
          Unable to load payment information. Please try refreshing the page or contact support.
        </Text>
      </FlexContainer>
    );
  }

  return (
    <FlexContainer flexDirection="column" gap="md" align="center">
      <FlexContainer flexDirection="column" align="center" gap="xxs">
        <Text weight="semibold" size="lg" style={{ textAlign: 'center' }}>
          Complete Your Payment
        </Text>
        <Text color="textSecondary" size="sm" style={{ textAlign: 'center' }}>
          Secure payment powered by Stripe
        </Text>
      </FlexContainer>

      <FlexContainer style={{ width: '100%', maxWidth: '500px' }}>
        <StripeUnpaidMembershipCheckout
          stripeProductId={membershipStatus.MembershipRate.StripeProductId}
          membershipStatusId={membershipStatus._id}
          customer_email={authUser.email}
          upgrade={false}
        />
      </FlexContainer>
    </FlexContainer>
  );
};

export default PaymentStep;
